import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** 12-col dashboard grid; widgets snap 4/6/8/12 (docs/design/00-design-system.md §4). */
export function DashboardGrid({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('grid grid-cols-12 gap-3.5', className)}>{children}</div>
}
